import React from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import Banner from "../../../component/Banner";
import Bannerimg from "../../../images/insurance/insurance-banner.webp";
import image1 from "../../../images/insurance/insurance1.webp";
import image2 from "../../../images/insurance/insurance2.webp";
import image3 from "../../../images/insurance/insurance3.webp";
import image4 from "../../../images/insurance/insurance4.webp";

const Insurance = () => {
  const banner = {
    title: "Insurance",
    image: Bannerimg,
  };
  const card = [
    {
      image: image1,
      title: "Life, Annuities & Retirement ",
      description:
        "Life, annuities and retirement for most life insurance providers do not mean readymade solutions but those solutions that enable them to focus on their core businesses while opening up a new world of opportunities.",
      tagName: "Learn More",
      tagLink: "life-annuities-retirement",
    },
    {
      image: image2,
      title: "Reinsurance",
      description:
        "Reinsurance is useful in managing the exposures that may exceed the risk capacity provided in the treaties or otherwise helps in reducing the overall efficiency of treaties in terms of pricing, structure and market.",
      tagName: "Learn More",
      tagLink: "reinsurance",
    },
    {
      image: image3,
      title: "Property & Casualty",
      description:
        "Property and casualty insurance helps in protecting your assets or any other property by providing liability coverage to help protect you, if you are found legally responsible for any risk or damage to the concerned property or assets.",
      tagName: "Learn More",
      tagLink: "propert-casualty",
    },
    {
      image: image4,
      title: "Insurance Broking",
      description:
        "The reality of high volatility market conditions and regulatory pressures require investment banks and broking firms to have a better understanding of their business, risks and operational efficiency to effectively compete in today’s complex investment banking and capital markets environment.",
      tagName: "Learn More",
      tagLink: "investment-banking-and-brokerage",
    },
  ];
  return (
    <>
      <>
        <Helmet>
          <title>
            Insurance — Cylon Technologies – Big Data | Data Analytics | Digital
            Strategy
          </title>
        </Helmet>
        <Banner heading={banner.title} bannerimg={banner.image} />
        <section className="sec-padd page_content pb-5">
          <div className="container">
            <h2 className="heading2 text-center pb-4">Insurance</h2>
            <p>
              The Insurance industry confronts major changes on a few fronts,
              like the markets are changing, client propensities are advancing
              on account of the accessibility of information, there is an
              interest for better administration, administrative instability
              prevails, the online and versatile situations are assuming a
              discriminating part later on of business and rivalry from
              non-customary players is developing. The business is at the apex
              of real change, with innovation along with technology assuming a
              bigger part in development.
            </p>
            <p>
              Insurance agencies are executing IT frameworks to comprehend their
              clients, create leads, computerize and modify each connection with
              them utilizing information from analysis. The Insurance business
              is troubled by endowed services and procedures. These have,
              throughout the years, turned out to be more intricate as they have
              must be coordinated with differing frameworks. With developing
              rivalry, Insurance organizations are being crushed on edges. Their
              centre is swinging to diminishing altered interests in
              administrations. Information administration projects are lavish,
              time intensive and hard to convey effectively in an Insurance
              domain. Cylon Technologies, deal with them effortlessly.
            </p>
            <div className="col-md-10 mx-auto">
              <div className="row g-md-5 g-4">
                {card.map((item, index) => (
                  <div className="col-md-6" key={index}>
                    <div className="img_card">
                      <img src={item.image} alt="images" />
                      <h2 className="heading2">{item.title}</h2>
                      <p>{item.description}</p>

                      {item.tagName && item.tagLink && (
                        <div className="btn_spacet">
                          <a
                            href={item.tagLink}
                            className="btn_small outline_blue"
                          >
                            {item.tagName}
                          </a>
                        </div>
                      )}
                    </div>
                  </div>
                ))}
              </div>
              <div className="text-center pt-5 mt-5">
                <Link
                  to="/connect"
                  className="btn_custom blue_btn"
                  href="Inquire"
                >
                  Inquire
                </Link>
              </div>
            </div>
          </div>
        </section>
      </>
    </>
  );
};

export default Insurance;
